import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";

import GKEvent from "../events";
import { Container, Row, Col } from "reactstrap";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { ajaxUri } from "../consts/index";
import { l } from "../functions";
import { Checkbox, Select, TextField } from "./FormElements";

const mapStateToProps = (state) => {
  return {
    fetchedThemes: state.rootReducer.fetchedThemes || {},
  };
};

const Loader = ({ color }) => {
  return (
    <div className={`gp-loader color-${color || 1} theme-dialog infinite`}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 40 40"
        className={`groove-logo speed-${color || 1}`}
      >
        <path d="M19.722 19.852h19.326c-.829 8.975-4.942 14.896-12.34 17.763-7.397 2.866-14.386 1.433-20.966-4.3l6.906-6.626c2.51 1.84 4.869 2.76 7.074 2.76 2.206 0 4.268-.844 6.186-2.532l-6.186-7.065zM0 19.36h9.909c.391-4.854 2.702-7.9 6.933-9.137 4.23-1.236 7.798.038 10.702 3.822l7.73-6.309C28.764.456 21.24-1.686 12.701 1.312 4.814 4.08.581 10.097 0 19.36z"></path>
      </svg>
    </div>
  );
};

class SaveDialog extends Component {
  constructor(props) {
    super(props);

    this.defaultState = {
      selectedTheme: "custom",
      customThemeName: "",
      savingTheme: true,
      pageList: [],
      checkedAll: false,
      checkedIndexList: [],
      jsonData: null,
      themeName: this.props.payload?.themeName || "",
      themeType: this.props.payload?.type || "",
      showLoader: null,
    };

    this.state = this.defaultState;

    this.themeOpetions = [];
  }

  componentDidUpdate(prevProps, state) {
    if (JSON.stringify(prevProps) != JSON.stringify(this.props)) {
      this.setState({
        themeName: this.props.payload?.themeName || "",
        themeType: this.props.payload?.type || "",
      });
    }
  }

  _themeNaming = (filename) => {
    return filename.split("_").join(" ").replace(".json", "");
  };

  _themeUNaming = (filename) => {
    return filename.split(" ").join("_") + ".json";
  };

  _checkFieldName = () => {
    if (this.state.selectedTheme === "custom") {
      const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~çèéêîôœû]/;

      if (this.state.customThemeName === "")
        return {
          error: true,
          message: l("Theme name is required"),
        };

      if (format.test(this.state.customThemeName))
        return {
          error: true,
          message: l("Characters only"),
        };
    }

    return {
      error: false,
      message: "",
    };
  };

  _loadTheme = (action = "") => {
    this.setState({ showLoader: true });
    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "loadTheme",
        filename: this.state.themeName,
        type: this.state.themeType,
        themeData: this.state.jsonData,
        pages: this.state.pageList.filter((item, index) =>
          this.state.checkedIndexList.includes(index)
        ),
        action: action,
      },
    })
      .then((res) => {
        console.log(res.data);
        if (res.data.status == "pending") {
          const data = res.data;
          const pagelist = data.pages;
          const jsonData = data.themeData;
          this.setState({
            pageList: pagelist,
            jsonData,
            savingTheme: false,
            showLoader: false,
          });
        } else if (res.data.status == "success") {
          // this.props.loadTheme();
          GKEvent.notification(res.data.status, res.data.message);
          setTimeout(() => {
            window.location.reload();
          }, 5000);
          this.props.payload.cb();
          this.setState(this.defaultState);
        } else {
          GKEvent.notification(
            res.data.status || "error",
            res.data.message || "Error while loading theme"
          );
          this.props.payload.cb();
          this.setState(this.defaultState);
        }
      })
      .catch((error) => {
        this.setState({ showLoader: null });
        GKEvent.notification(
          "error",
          l("Error while loading the theme. Please try again.")
        );
      });
  };

  _saveTheme = () => {
    let name;

    if (this.state.selectedTheme === "custom")
      name = this._themeUNaming(this.state.customThemeName);
    else name = this.state.selectedTheme;

    axios({
      method: "post",
      url: ajaxUri,
      data: {
        request: "saveTheme",
        filename: name,
      },
    })
      .then((result) => {
        GKEvent.notification(result.data.status, result.data.message);

        if (result.data.status === "success") this._loadTheme();
      })
      .catch((error) => {
        GKEvent.notification(
          "error",
          l("Error while saving the theme. Please try again.")
        );
      });
  };

  _customeThemeNameGenerator() {
    const number = Math.floor(Math.random() * 1000);
    const themeName = "Custom Theme " + number.toString();

    if (!this.state.customThemeName) {
      this.setState({ customThemeName: themeName });
    }

    return themeName;
  }

  _closeDialog = () => {
    this.setState(this.defaultState, () => {
      this.props.closeDialog && this.props.closeDialog();
    });
  };

  _themeSelectionOption() {
    let themes = this.props.fetchedThemes.my_themes || [];
    let toReturn = [];

    themes.map((theme, index) => {
      toReturn.push({ value: theme, label: this._themeNaming(theme) });
    });

    toReturn.push({ value: "custom", label: "custom" });
    this.themeOpetions = toReturn;
    return toReturn;
  }

  _addRemoveCheckedList = (index, checked, addAll = false) => {
    let checkedList = this.state.checkedIndexList;
    if (addAll && checked === null) {
      checkedList = [];
      this.state.pageList.forEach((item, index) => checkedList.push(index));
      this.setState({ checkedIndexList: [...checkedList] });
      return;
    } else if (checked === null) {
      checkedList = [];
      this.setState({ checkedIndexList: [...checkedList] });
      return;
    }
    if (checked) {
      checkedList.push(index);
    } else {
      checkedList = checkedList.filter((item) => item !== index);
    }
    console.log(checked, checkedList);
    this.setState({ checkedIndexList: [...checkedList], checkedAll: false });
  };
  render() {
    return (
      <Dialog
        open={this.props.open ? true : false}
        onClose={() => {
          this._closeDialog();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {this.state.showLoader && <Loader />}
        {!this.state.savingTheme && (
          <>
            <DialogTitle id="alert-dialog-title">
              {l("Found duplicate page(s) while loading the theme:")}
            </DialogTitle>
            <DialogContent>
              <div className="conflict-pages-list">
                <ul>
                  <li>
                    <span>Name</span>
                    <span>URL</span>
                    <Checkbox
                      label="Select all"
                      checked={this.state.checkedAll}
                      onChange={(target) => {
                        this.setState({ checkedAll: target });
                        this._addRemoveCheckedList(null, null, target);
                      }}
                    />
                  </li>
                  {this.state.pageList.map((item, index) => {
                    const { name, url, meta_title, link_rewrite } = item;

                    return (
                      <li>
                        <span>{name || meta_title}</span>
                        <span>{url || link_rewrite}</span>
                        <Checkbox
                          checked={this.state.checkedIndexList.includes(index)}
                          onChange={(traget) =>
                            this._addRemoveCheckedList(index, traget)
                          }
                        />
                      </li>
                    );
                  })}
                </ul>
              </div>
            </DialogContent>
            <DialogActions>
              <button
                onClick={() => {
                  this._loadTheme("REPLACE_ALL");
                }}
                className="gk-button gk-primary gk-danger gk-small"
              >
                <span>{l("Replace")}</span>
              </button>
              <button
                onClick={() => {
                  this._loadTheme("IGNORE_ALL");
                }}
                className="gk-button gk-primary gk-danger gk-small"
                style={{ backgroundColor: "transparent", color: "red" }}
              >
                <span style={{ color: "#e75f44" }}>{l("Skip these")}</span>
              </button>
              <button
                onClick={() => {
                  this._loadTheme("SAVE_PAGES");
                }}
                disabled={!this.state.checkedIndexList.length}
                className="gk-button gk-primary gk-default gk-small"
              >
                <span>{l("Create New")}</span>
              </button>
            </DialogActions>
          </>
        )}
        {this.state.savingTheme && (
          <>
            <DialogTitle id="alert-dialog-title">
              {l(
                "All your Pages except custom pages will be replaced by Theme Pages"
              )}
            </DialogTitle>
            <DialogContent>
              <Container>
                <Row>
                  <Col sm={6}>
                    <DialogContentText id="alert-dialog-description">
                      {l(
                        "You can save you current theme's datas by selecting an exisiting theme to replace or creating a new theme."
                      )}
                    </DialogContentText>
                  </Col>
                  <Col sm={6}>
                    <FormControl component="fieldset" style={{ width: 200 }}>
                      <FormLabel component="legend">{l("Save to :")}</FormLabel>
                      <div style={{ marginTop: 5 }} />
                      {/* <RadioGroup
                    aria-label="gender"
                    value={this.state.selectedTheme || "custom"}
                    onChange={(event) => {
                      const value = event.target.value;

                      this.setState(
                        {
                          selectedTheme: value,
                        },
                        () => {
                          //   if (value !== "custom")
                          // this.setState({ customThemeName: "" });
                        }
                      );
                    }}
                  >
                    {this.props.fetchedThemes.my_themes &&
                      this.props.fetchedThemes.my_themes.map((theme, index) => (
                        <FormControlLabel
                          key={index}
                          value={theme}
                          control={<Radio />}
                          label={this._themeNaming(theme)}
                        />
                      ))}
                    <FormControlLabel
                      value={"custom"}
                      control={<Radio />}
                      label={
                        <TextField
                          placeholder={l("Theme's name")}
                          size="small"
                          value={
                            this.state.customThemeName ||
                            this._customeThemeNameGenerator()
                          }
                          onChange={(value) => {
                            this.setState({ customThemeName: value });
                          }}
                          onClick={() => {
                            this.setState({ selectedTheme: "custom" });
                          }}
                          error={this._checkFieldName().message || null}
                        />
                      }
                    />
                  </RadioGroup> */}

                      <Select
                        value={this.state.selectedTheme}
                        onChange={(value) => {
                          this.setState({ selectedTheme: value });
                        }}
                        options={this._themeSelectionOption()}
                      />

                      <div style={{ marginTop: 10 }} />

                      {this.state.selectedTheme == "custom" && (
                        <TextField
                          placeholder={l("Theme's name")}
                          size="small"
                          value={
                            this.state.customThemeName ||
                            this._customeThemeNameGenerator()
                          }
                          onChange={(value) => {
                            this.setState({ customThemeName: value });
                          }}
                          onClick={() => {
                            this.setState({ selectedTheme: "custom" });
                          }}
                          error={this._checkFieldName().message || null}
                        />
                      )}
                    </FormControl>
                  </Col>
                </Row>
              </Container>
            </DialogContent>
            <DialogActions>
              <button
                onClick={() => {
                  // this._closeDialog();
                  this.props.payload.cb();
                }}
                className="gk-button gk-primary gk-danger gk-small"
              >
                <span>{l("Cancel")}</span>
              </button>
              <button
                onClick={() => {
                  this._loadTheme();
                }}
                className="gk-button gk-primary gk-danger gk-small"
                style={{ backgroundColor: "transparent", color: "red" }}
              >
                <span style={{ color: "#e75f44" }}>
                  {l("Ignore saving theme")}
                </span>
              </button>
              <button
                onClick={() => {
                  this._saveTheme();
                }}
                disabled={
                  this._checkFieldName().error || !this.state.selectedTheme
                }
                className="gk-button gk-primary gk-default gk-small"
              >
                <span>{l("Save")}</span>
              </button>
            </DialogActions>
          </>
        )}
      </Dialog>
    );
  }
}

export default connect(mapStateToProps)(React.memo(SaveDialog));
